module.exports = __webpack_public_path__ + "media/images/flags/rs-13db15f1adddaa6757b5e06575c7088d.svg";